import { forwardRef } from 'react'
import { Box, Typography } from '@mui/material'
import NotificationStatsCard from './NotificationStatsCard'
import { NotificationStats } from '@/mockdata/notifications'

export interface NotificationStatsListProps {
  items: NotificationStats[]
  onItemClick?: (item: NotificationStats) => void
  emptyText?: string
  maxHeight?: string | number
  isEditMode?: boolean
  onReorder?: (startIndex: number, endIndex: number) => void
}

export const NotificationStatsList = forwardRef<
  HTMLDivElement,
  NotificationStatsListProps
>(
  (
    {
      items,
      onItemClick,
      emptyText = 'אין נתונים',
      maxHeight = '300px',
      isEditMode = false,
      onReorder,
    },
    ref
  ) => {
    if (items.length === 0) {
      return (
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary" sx={{fontFamily: 'Rubik, sans-serif',}}>
            {emptyText}
          </Typography>
        </Box>
      )
    }

    return (
      <Box
        ref={ref}
        sx={{
          ...(maxHeight === 'none' ? { flex: 1, height: 0 } : { maxHeight }),
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '8px',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollBehavior: 'smooth',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
          }}
        >
          {items.map((item, index) => (
            <NotificationStatsCard
              key={item.id}
              item={item}
              onClick={onItemClick}
              isEditMode={isEditMode}
              isDraggable={isEditMode}
              onDrop={(dragIndex: number) => {
                if (onReorder && dragIndex !== index) {
                  onReorder(dragIndex, index)
                }
              }}
              index={index}
            />
          ))}
        </Box>
      </Box>
    )
  }
)

NotificationStatsList.displayName = 'NotificationStatsList'

export default NotificationStatsList
